
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ChiSiamo from "../pages/chi-siamo/page";
import Contatti from "../pages/contatti/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/chi-siamo",
    element: <ChiSiamo />,
  },
  {
    path: "/contatti",
    element: <Contatti />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;